import React, { useState, useEffect } from "react";
import {
  Grid,
  Box,
  Stack,
  Button,
  Typography,
  Divider,
  TextField,
  Alert,
  Select,
  MenuItem,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import AddScoreCardModal from "../AddScoreCard";
import ProfileInfo from "../ProfileInfo";
import { apiGet, apiPut } from "../../../utils/apiRequests";
import ApiEndpoints from "../../../utils/ApiEndpoints";
import LoadingButton from "@mui/lab/LoadingButton";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import "react-circular-progressbar/dist/styles.css";

import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  outlineInputBorder: {
    "& * > input": {
      padding: "5px 14px !important",
    },
    "& * > fieldset": {
      top: "0 !important",
    },
    "& * > fieldset > legend": {
      display: "none !important",
    },
    "& > fieldset > legend > span": {
      display: "none",
    },
  },
  playerprofilebtn: {
    backgroundColor: "#06623B !important",
    color: "#FFF !important",
    borderRadius: "5px !important",
    fontWeight: "400 !important",
    minWidth: "175px !important",
    padding: "10px 20px !important",
    textTransform: "capitalize !important",
  },
  playerprofileUpdatebtn: {
    backgroundColor: "#06623B !important",
    color: "#FFF !important",
    borderRadius: "5px !important",
    fontWeight: "400 !important",
    minWidth: "175px !important",
    padding: "10px 20px !important",
    textTransform: "capitalize !important",
    "&>div": {
      color: "WHITE",
      whiteSpace: "nowrap",
    },
  },
  profileHeader: {
    width: "70%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center !important",
    alignItems: "center !important",
    position: "relative",
  },
  profileImgContainer: {
    display: "inline-block",
    width: "150px",
    height: "150px",
    borderRadius: "100%",
    border: "5px solid white",
    position: "absolute",
    top: "100px",
    left: "calc(50% - 80px)",
    right: 0,
    background: "#fff",
  },
  profileImg: {
    width: "100%",
    maxHeight: "100%",
    borderRadius: "100%",
  },
  profileHeaderText: {
    backgroundColor: "#06623B !important",
    paddingTop: 10,
    paddingBottom: 100,
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  socialBtn: {
    cursor: "pointer",
    backgroundColor: "#000000",
    padding: 10,
    margin: 5,
    width: 40,
    height: 40,
    borderRadius: 100,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  scoreIcon: {
    width: 30,
    height: 30,
    marginRight: 15,
  },
  divider: {
    width: "2% !important",
    height: "100% !important",
  },
  social_link: {
    width: 20,
    height: 20,
  },
  social_link_fields: {
    padding: "40px",
  },
  fb_button: {
    backgroundColor: "#3B5998 !important",
    color: "#FFF !important",
    textTransform: "capitalize !important",
    fontSize: 18,
    width: "100%",
    height: 40,
    borderRadius: "4px 4px 0 0 !important",
  },
  twitter_button: {
    backgroundColor: "#55ACEE !important",
    color: "#FFF !important",
    textTransform: "capitalize !important",
    fontSize: 18,
    width: "100%",
    height: 40,
    borderRadius: "4px 4px 0 0 !important",
  },
  instagram_button: {
    backgroundColor: "#09416A !important",
    color: "#FFF !important",
    textTransform: "capitalize !important",
    fontSize: 18,
    width: "100%",
    height: 40,
    borderRadius: "4px 4px 0 0 !important",
  },
  linkedIn_button: {
    backgroundColor: "#0E76A8 !important",
    color: "#FFF !important",
    textTransform: "capitalize !important",
    fontSize: 18,
    width: "100%",
    height: 40,
    borderRadius: "4px 4px 0 0 !important",
  },
  social_link_input: {
    "& * > div": {
      borderRadius: "0 0 4px 4px !important",
    },
    "& * > input": {
      padding: "5px 14px !important",
      backgroundColor: "#fff",
    },
    "& * > fieldset": {
      top: "0 !important",
    },
    "& * > fieldset > legend": {
      display: "none !important",
    },
  },
}));

export default function PlayerAccountSettings({
  playerData,
  playerID,
  averageScore,
}) {
  const classes = useStyles();

  // Selector
  const { role } = useSelector((state) => state.userDetailsReducer);

  // State

  // const [dataFetched, setDataFetchedState] = useState(false);
  const [openAddScoreModal, setOpenAddScoreModal] = useState(false);
  const [userData, setUserData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    mobile_number: "",
    unique_initials: "",
    user_tee: [],
    user_role: "",
    company: "",
    role_in_company: "",
    website: "",
    member_since: "",
    social_links: [],
    poty_rank: 0,
  });
  const [defaultTee, setDefaultTee] = useState("");
  const [isError, setIsError] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState("Error");
  const [successMessage, setSuccessMessage] = useState("");
  const [isUpdated, setIsUpdated] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [userRole, setUserRole] = useState(null);

  const [socialLinks, setSocialLinks] = useState({
    Facebook: "",
    Twitter: "",
    Instagram: "",
    LinkedIn: "",
  });

  const token = localStorage.getItem("token");

  const handleAddScoreModalOpen = () => {
    setOpenAddScoreModal(true);
  };
  const handleAddScoreModalClose = () => {
    setOpenAddScoreModal(false);
  };

  const _handleChangeTee = (value) => {
    setDefaultTee(value);
    setUserData((prev) => {
      const modifiedTees = prev.user_tee.map((tee) => {
        if (tee.tee_color == value.toLowerCase()) {
          return { ...tee, is_default: true };
        } else {
          return { ...tee, is_default: false };
        }
      });

      return { ...prev, user_tee: modifiedTees };
    });
  };

  const inputChangeHandler = (e) => {
    var { name, value } = e.target;

    setUserData((pre) => {
      return {
        ...pre,
        [name]: value,
      };
    });
  };

  const handleChangeUserRole = (e) => {
    const { name, value } = e.target;

    setUserRole(value);

    let playerRole = [];

    if (value === "Super_Admin") {
      playerRole = ["Player", "Admin", "Super_Admin"];
    } else if (value === "Admin") {
      playerRole = ["Player", "Admin"];
    } else if (value === "Player") {
      playerRole = ["Player"];
    }

    setUserData((pre) => {
      return {
        ...pre,
        [name]: playerRole,
      };
    });
  };

  const _handleSubmit = () => {
    var l_socialLinks = Object.keys(socialLinks).map((link) => {
      return {
        name: link,
        link: socialLinks[link],
      };
    });

    setUserData((pre) => {
      return {
        ...pre,
        social_links: l_socialLinks,
      };
    });

    setIsUpdating(true);

    if (role === "admin" || role === "super") {
      apiPut(
        `${ApiEndpoints.users.base}${ApiEndpoints.users.edit}${playerID}`,
        { ...userData, social_links: l_socialLinks },
        (response) => {
          setIsSuccess(true);
          setSuccessMessage(response.message);
          setIsUpdating(false);
          setIsUpdated(true);
          setTimeout(() => {
            setIsUpdated(false);
            setIsSuccess(false);
            setIsError(false);
          }, 2500);
        },
        (err) => {
          setIsError(true);
          setErrorMessage(err.message);
          setIsUpdating(false);
        }
      );
    } else {
      apiPut(
        `${ApiEndpoints.profile.base}${ApiEndpoints.profile.edit}${playerID}`,
        { ...userData, social_links: l_socialLinks },
        (response) => {
          setIsSuccess(true);
          setSuccessMessage(response.message);
          setIsUpdating(false);
          setIsUpdated(true);
          setTimeout(() => {
            setIsUpdated(false);
            setIsSuccess(false);
            setIsError(false);
          }, 2500);
        },
        (err) => {
          setIsError(true);
          setErrorMessage(err.message);
          setIsUpdating(false);
        }
      );
    }
  };

  const getUserInfo = () => {
    apiGet(
      `${ApiEndpoints.user.base}/basic-info/${playerID}`,
      (response) => {
        setUserData(response?.data);

        let superAdminRole = response?.data.user_role.filter((val) =>
          val.includes("Super_Admin")
        );

        if (superAdminRole.length === 0) {
          let adminRole = response?.data?.user_role.filter((val) =>
            val.includes("Admin")
          );

          if (adminRole.length === 0) {
            setUserRole("Player");
          } else {
            setUserRole("Admin");
          }
        } else {
          setUserRole("Super_Admin");
        }
      },
      (err) => console.log(err)
    );
  };

  const _handleSocialOnChange = (e) => {
    var { name, value } = e.target;

    setSocialLinks((pre) => {
      return {
        ...pre,
        [name]: value,
      };
    });
  };
  useEffect(() => {
    getUserInfo();
  }, []);

  useEffect(() => {
    if (userData?.social_links.length > 0) {
      var l_social = { ...socialLinks };
      var social_facebook = userData?.social_links?.filter(
        (sl) => sl.name.toLowerCase() === "facebook"
      );
      var social_twitter = userData?.social_links?.filter(
        (sl) => sl.name.toLowerCase() === "twitter"
      );
      var social_instagram = userData?.social_links?.filter(
        (sl) => sl.name.toLowerCase() === "instagram"
      );
      var social_linkedIn = userData?.social_links?.filter(
        (sl) => sl.name.toLowerCase() === "linkedin"
      );
      if (social_facebook.length > 0)
        l_social.Facebook = social_facebook[0].link;
      if (social_twitter.length > 0) l_social.Twitter = social_twitter[0].link;
      if (social_instagram.length > 0)
        l_social.Instagram = social_instagram[0].link;
      if (social_linkedIn.length > 0)
        l_social.LinkedIn = social_linkedIn[0].link;
      setSocialLinks(l_social);
    }
    if (userData?.user_tee.length > 0) {
      var default_tee = userData?.user_tee?.filter(
        (tee) => tee.is_default === true
      )[0];
      if (default_tee)
        setDefaultTee(
          default_tee.tee_color.charAt(0).toUpperCase() +
            default_tee.tee_color.slice(1)
        );
    }
  }, [userData.user_role]);

  return (
    <Grid container p={3}>
      <Grid item xs={12}>
        {isError && (
          <Alert variant="filled" severity="error">
            {`Error: ${errorMessage}`}
          </Alert>
        )}
        {isSuccess && (
          <Alert variant="filled" severity="success">
            {successMessage}
          </Alert>
        )}

        <Grid container pt={3}>
          <Grid item xs={12} md={3}>
            <ProfileInfo playerData={userData} average={averageScore} />
          </Grid>
          <Grid item xs={0} md={1} display="flex" justifyContent="center">
            <Divider orientation="vertical" className={classes.divider} />
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography variant="h6" sx={{ fontWeight: "600", pb: "2px" }}>
              Account Settings
            </Typography>

            <Divider
              orientation="horizontal"
              sx={{ height: "3px !important", margin: "7px 0 30px" }}
            />
            <Grid container sx={{ display: "flex" }}>
              <Grid item xs={12} md={6} px={1}>
                <Stack direction="column" spacing={3}>
                  <Grid container sx={{ display: "flex" }}>
                    <Grid item xs={12} md={4}>
                      <Typography variant="subtitle2" fontWeight={"600"}>
                        First Name
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={8}>
                      <TextField
                        fullWidth
                        value={userData?.first_name}
                        onChange={inputChangeHandler}
                        name="first_name"
                        className={classes.outlineInputBorder}
                      />
                    </Grid>
                  </Grid>
                  <Grid container sx={{ display: "flex" }}>
                    <Grid item xs={12} md={4}>
                      <Typography variant="subtitle2" fontWeight={"600"}>
                        Last Name
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={8}>
                      <TextField
                        fullWidth
                        value={userData?.last_name}
                        onChange={inputChangeHandler}
                        name="last_name"
                        className={classes.outlineInputBorder}
                      />
                    </Grid>
                  </Grid>
                  <Grid container sx={{ display: "flex" }}>
                    <Grid item xs={12} md={4}>
                      <Typography variant="subtitle2" fontWeight={"600"}>
                        Email
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={8}>
                      <TextField
                        fullWidth
                        value={userData?.email}
                        onChange={inputChangeHandler}
                        name="email"
                        sx={{
                          backgroundColor: "transparent",
                          color: "#000000",
                        }}
                        className={classes.outlineInputBorder}
                      />
                    </Grid>
                  </Grid>
                  <Grid container sx={{ display: "flex" }}>
                    <Grid item xs={12} md={4}>
                      <Typography variant="subtitle2" fontWeight={"600"}>
                        Mobile No.
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={8}>
                      <TextField
                        fullWidth
                        value={userData?.mobile_no}
                        onChange={inputChangeHandler}
                        name="mobile_no"
                        sx={{
                          backgroundColor: "transparent",
                          color: "#000000",
                        }}
                        className={classes.outlineInputBorder}
                      />
                    </Grid>
                  </Grid>
                  <Grid container sx={{ display: "flex" }}>
                    <Grid item xs={12} md={4}>
                      <Typography variant="subtitle2" fontWeight={"600"}>
                        Company
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={8}>
                      <TextField
                        fullWidth
                        value={userData?.company}
                        onChange={inputChangeHandler}
                        name="company"
                        sx={{
                          backgroundColor: "transparent",
                          color: "#000000",
                        }}
                        className={classes.outlineInputBorder}
                      />
                    </Grid>
                  </Grid>
                  <Grid container sx={{ display: "flex" }}>
                    <Grid item xs={12} md={4}>
                      <Typography variant="subtitle2" fontWeight={"600"}>
                        Designation
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={8}>
                      <TextField
                        fullWidth
                        value={userData.role_in_company}
                        onChange={inputChangeHandler}
                        name="role_in_company"
                        sx={{
                          backgroundColor: "transparent",
                          color: "#000000",
                        }}
                        className={classes.outlineInputBorder}
                      />
                    </Grid>
                  </Grid>
                  <Grid container sx={{ display: "flex" }}>
                    <Grid item xs={12} md={4}>
                      <Typography variant="subtitle2" fontWeight={"600"}>
                        Website
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={8}>
                      <TextField
                        fullWidth
                        value={userData?.website}
                        onChange={inputChangeHandler}
                        name="website"
                        sx={{
                          backgroundColor: "transparent",
                          color: "#000000",
                        }}
                        className={classes.outlineInputBorder}
                      />
                    </Grid>
                  </Grid>
                  <Grid container sx={{ display: "flex" }}>
                    <Grid item xs={12} md={4}>
                      <Typography variant="subtitle2" fontWeight={"600"}>
                        User Type
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={8}>
                      <Select
                        variant="outlined"
                        value={userRole}
                        className={classes.outlineInputBorder}
                        name="user_role"
                        fullWidth
                        label="."
                        placeholder="Inactive"
                        onChange={handleChangeUserRole}
                      >
                        {["Super_Admin", "Admin", "Player"].map((item) => (
                          <MenuItem key={item} value={item}>
                            <Grid container item>
                              <Grid item xs={10}>
                                {item}
                              </Grid>
                            </Grid>
                          </MenuItem>
                        ))}
                      </Select>
                    </Grid>
                  </Grid>

                  <Grid container sx={{ display: "flex" }}>
                    <Grid item xs={12} md={4}>
                      <Typography variant="subtitle2" fontWeight={"600"}>
                        Member Since
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={8}>
                      <TextField
                        fullWidth
                        value={userData.member_since}
                        onChange={inputChangeHandler}
                        name="member_since"
                        className={classes.outlineInputBorder}
                        type="numer"
                        min="1900"
                        max="2099"
                        step="1"
                      />
                    </Grid>
                  </Grid>
                  <Grid container sx={{ display: "flex" }}>
                    <Grid item xs={12} md={4}>
                      <Typography variant="subtitle2" fontWeight={"600"}>
                        Unique Initials
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={8}>
                      <TextField
                        fullWidth
                        value={userData?.unique_initials}
                        onChange={inputChangeHandler}
                        name="unique_initials"
                        className={classes.outlineInputBorder}
                      />
                    </Grid>
                  </Grid>
                  <Grid container>
                    <Grid item xs={12} md={4}>
                      <Typography variant="subtitle2" fontWeight={"600"}>
                        Default Tee
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={8}>
                      <Select
                        variant="outlined"
                        value={defaultTee}
                        className={classes.outlineInputBorder}
                        name="defaultTee"
                        fullWidth
                        label="."
                        placeholder="Inactive"
                      >
                        {["White", "Yellow", "Blue", "Black"].map((item) => (
                          <MenuItem
                            key={item}
                            value={item}
                            onClick={() => _handleChangeTee(item)}
                          >
                            <Grid container item>
                              <Grid item xs={10}>
                                {item}
                              </Grid>
                            </Grid>
                          </MenuItem>
                        ))}
                      </Select>
                    </Grid>
                  </Grid>
                </Stack>
              </Grid>
              <Grid
                item
                xs={0}
                md={1}
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <Divider orientation="vertical" className={classes.divider} />
              </Grid>
              <Grid
                item
                xs={12}
                md={5}
                px={1}
                marginTop={{ xs: "20px", md: 0 }}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <Typography
                  variant="h6"
                  textAlign={"center"}
                  fontWeight={"600"}
                >
                  Social Links
                </Typography>

                <Divider
                  orientation="horizontal"
                  sx={{ height: "1px !important", marginBottom: "22px" }}
                />

                <Grid container>
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        mt: 1,
                        mb: 1,
                      }}
                    >
                      <Button
                        className={classes.fb_button}
                        startIcon={<FacebookIcon />}
                        disabled
                      >
                        Facebook
                      </Button>
                      <TextField
                        fullWidth
                        placeholder="facebook.com/"
                        variant="outlined"
                        className={classes.outlineInputBorder}
                        name="Facebook"
                        value={socialLinks.Facebook}
                        onChange={_handleSocialOnChange}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        mt: 2,
                        mb: 1,
                      }}
                    >
                      <Button
                        className={classes.twitter_button}
                        startIcon={<TwitterIcon />}
                        disabled
                      >
                        Twitter
                      </Button>
                      <TextField
                        fullWidth
                        placeholder="twitter.com/"
                        variant="outlined"
                        className={classes.outlineInputBorder}
                        name="Twitter"
                        value={socialLinks.Twitter}
                        onChange={_handleSocialOnChange}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        mt: 2,
                        mb: 1,
                      }}
                    >
                      <Button
                        className={classes.instagram_button}
                        startIcon={<InstagramIcon />}
                        disabled
                      >
                        Instagram
                      </Button>
                      <TextField
                        fullWidth
                        placeholder="instagram.com/"
                        variant="outlined"
                        className={classes.outlineInputBorder}
                        name="Instagram"
                        value={socialLinks.Instagram}
                        onChange={_handleSocialOnChange}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        mt: 2,
                        mb: 1,
                      }}
                    >
                      <Button
                        className={classes.linkedIn_button}
                        startIcon={<LinkedInIcon />}
                        disabled
                      >
                        LinkedIn
                      </Button>
                      <TextField
                        fullWidth
                        placeholder="linkedin.com/"
                        variant="outlined"
                        className={classes.outlineInputBorder}
                        name="LinkedIn"
                        value={socialLinks.LinkedIn}
                        onChange={_handleSocialOnChange}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid container>
          <Grid
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <LoadingButton
              loading={isUpdating}
              onClick={_handleSubmit}
              className={classes.playerprofileUpdatebtn}
              variant="outlined"
              sx={{
                width: 180,
                height: 40,
                backgroundColor: isUpdated ? "#2C633C" : "#E80303",
                color: "#FFF !important",
                whiteSpace: "nowrap !important",
                borderRadius: "10px",
              }}
            >
              <span>
                {isUpdated ? "Profile Updated!" : isUpdating ? "" : "Update"}
              </span>
            </LoadingButton>
          </Grid>
        </Grid>
      </Grid>
      {openAddScoreModal ? (
        <AddScoreCardModal
          handleOpenModal={handleAddScoreModalOpen}
          handleCloseModal={handleAddScoreModalClose}
        />
      ) : (
        <></>
      )}
    </Grid>
  );
}
